/**
* 头部菜单
*/
<template>
  <div class="topbar">
    <el-button class="buttonimg" type="text" @click="toggle(collapsed)">
      <img class="showimg" :src="collapsed?imgsq:imgshow">
    </el-button>
    <div class="weather" :title="weatherTip">
      <span class="weather-ico" v-html="weatherSvg"></span>
      <span class="weather-temp" v-if="weatherTemp !== null">{{ weatherTemp }}°</span>
      <span class="weather-text">{{ weatherCity || weatherText }}</span>
    </div>
    <div class="welcome">今天也要认真看房源呀</div>
    <el-dropdown class="userbox" trigger="click" @command="onCommand">
      <span class="user-trigger">
        <span class="avatar">{{ avatarText }}</span>
        <span class="uname">{{ displayName }}</span>
        <i class="el-icon-arrow-down"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="exit">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
function weatherMeta(code) {
  const n = Number(code)
  if (n === 0) {
    return { text: '晴', svg: '<svg viewBox="0 0 24 24" width="22" height="22"><circle cx="12" cy="12" r="5" fill="#f59e0b"/><g stroke="#f59e0b" stroke-width="2" stroke-linecap="round"><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></g></svg>' }
  }
  if (n <= 3) {
    return { text: '多云', svg: '<svg viewBox="0 0 24 24" width="22" height="22"><circle cx="8" cy="10" r="4" fill="#f59e0b"/><path d="M7 17h10a4 4 0 0 0 0-8 5.5 5.5 0 0 0-10.5 2A3.5 3.5 0 0 0 7 17z" fill="#93c5fd"/></svg>' }
  }
  if (n === 45 || n === 48) {
    return { text: '雾', svg: '<svg viewBox="0 0 24 24" width="22" height="22"><g stroke="#94a3b8" stroke-width="2" stroke-linecap="round"><path d="M4 9h16M3 13h18M6 17h12"/></g></svg>' }
  }
  if ((n >= 71 && n <= 77) || n === 85 || n === 86) {
    return { text: '雪', svg: '<svg viewBox="0 0 24 24" width="22" height="22"><path d="M7 16h10a4 4 0 0 0 0-8 5.5 5.5 0 0 0-10.5 2A3.5 3.5 0 0 0 7 16z" fill="#bfdbfe"/><g fill="#38bdf8"><circle cx="9" cy="19" r="1.2"/><circle cx="13" cy="20" r="1.2"/><circle cx="16" cy="18.5" r="1.2"/></g></svg>' }
  }
  if (n >= 95) {
    return { text: '雷雨', svg: '<svg viewBox="0 0 24 24" width="22" height="22"><path d="M7 14h10a4 4 0 0 0 0-8 5.5 5.5 0 0 0-10.5 2A3.5 3.5 0 0 0 7 14z" fill="#64748b"/><path d="M11 14l-2 5h3l-1 4 4-6h-3l2-3z" fill="#f59e0b"/></svg>' }
  }
  return { text: '雨', svg: '<svg viewBox="0 0 24 24" width="22" height="22"><path d="M7 15h10a4 4 0 0 0 0-8 5.5 5.5 0 0 0-10.5 2A3.5 3.5 0 0 0 7 15z" fill="#60a5fa"/><g stroke="#38bdf8" stroke-width="1.8" stroke-linecap="round"><path d="M9 17v3M12 18v3M15 17v3"/></g></svg>' }
}

export default {
  name: 'navcon',
  data() {
    return {
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      user: {},
      weatherTemp: null,
      weatherText: '天气',
      weatherCity: '',
      weatherSvg: weatherMeta(2).svg
    }
  },
  computed: {
    displayName() {
      return (this.user && (this.user.userName || this.user.name)) || '管理员'
    },
    avatarText() {
      return String(this.displayName).slice(0, 1).toUpperCase()
    },
    weatherTip() {
      const place = this.weatherCity || '当前所在地'
      if (this.weatherTemp === null) return place + '当日天气'
      return place + ' ' + this.weatherText + ' ' + this.weatherTemp + '℃'
    }
  },
  created() {
    try {
      this.user = JSON.parse(localStorage.getItem('userdata') || '{}')
    } catch (e) {
      this.user = {}
    }
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !!value
    })
    this.loadWeather()
  },
  methods: {
    onCommand(cmd) {
      if (cmd === 'exit') this.exit()
    },
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          setTimeout(() => {
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '已退出登录!'
            })
          }, 1000)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    },
    loadWeather() {
      this.locateUser().then(loc => {
        if (loc.city) this.weatherCity = loc.city
        return this.fetchWeather(loc.lat, loc.lng).then(() => {
          if (!this.weatherCity) return this.reverseCity(loc.lat, loc.lng)
        })
      }).catch(() => {})
    },
    locateUser() {
      return this.locateByGps().catch(() => this.locateByIp())
    },
    locateByGps() {
      return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          reject(new Error('no gps'))
          return
        }
        navigator.geolocation.getCurrentPosition((pos) => {
          resolve({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
            city: ''
          })
        }, () => reject(new Error('gps denied')), {
          enableHighAccuracy: false,
          timeout: 4000,
          maximumAge: 1800000
        })
      })
    },
    locateByIp() {
      return this.$axios.get('https://ipwho.is/').then(res => {
        const d = (res && res.data) || {}
        if (!d.success || d.latitude == null || d.longitude == null) {
          return Promise.reject(new Error('ip locate fail'))
        }
        return {
          lat: d.latitude,
          lng: d.longitude,
          city: d.city || d.region || ''
        }
      })
    },
    reverseCity(lat, lng) {
      return this.$axios.get('https://geocoding-api.open-meteo.com/v1/reverse', {
        params: {
          latitude: lat,
          longitude: lng,
          language: 'zh',
          count: 1
        }
      }).then(res => {
        const hit = (((res && res.data && res.data.results) || [])[0]) || {}
        this.weatherCity = hit.admin1 || hit.name || hit.country || this.weatherCity
      }).catch(() => {})
    },
    fetchWeather(lat, lng) {
      return this.$axios.get('https://api.open-meteo.com/v1/forecast', {
        params: {
          latitude: lat,
          longitude: lng,
          current_weather: true,
          timezone: 'auto'
        }
      }).then(res => {
        const cur = (res && res.data && res.data.current_weather) || {}
        if (cur.temperature == null) return
        const meta = weatherMeta(cur.weathercode)
        this.weatherTemp = Math.round(Number(cur.temperature))
        this.weatherText = meta.text
        this.weatherSvg = meta.svg
      })
    }
  }
}
</script>
<style scoped>
.topbar {
  height: 100%;
  min-height: 48px;
  display: flex;
  align-items: center;
  padding: 0 20px 0 6px;
  padding-right: max(20px, env(safe-area-inset-right));
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0 8px 24px rgba(91, 103, 241, 0.06);
}
.buttonimg {
  height: 40px;
  padding: 0 4px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 22px;
  height: 22px;
}
.weather {
  display: flex;
  align-items: center;
  margin-left: 0;
  padding: 4px 10px;
  border-radius: 999px;
  background: linear-gradient(135deg, #eef2ff, #fff7ed);
  color: #1f1633;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
}
.weather-ico {
  display: inline-flex;
  width: 22px;
  height: 22px;
}
.weather-ico >>> svg {
  display: block;
}
.weather-temp {
  margin-left: 4px;
  color: #5b67f1;
}
.weather-text {
  margin-left: 4px;
  color: #6b6480;
  font-weight: 500;
}
.welcome {
  margin-left: 8px;
  color: #6b6480;
  font-size: 13px;
}
.userbox {
  margin-left: auto;
}
.user-trigger {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #1f1633;
}
.avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff6b6b, #8b5cf6);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  margin-right: 8px;
}
.uname {
  font-weight: 600;
  margin-right: 6px;
}

@media (orientation: landscape) and (max-height: 540px) {
  .welcome {
    display: none;
  }
  .weather-text {
    display: none;
  }
  .weather {
    padding: 2px 8px;
  }
  .uname {
    max-width: 88px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

@media (orientation: landscape) and (min-width: 768px) and (max-width: 1024px) {
  .welcome {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navcon.vue